<template>
  <div class="reservation-charges-tab">
    <div class="row">
      <div class="col-xs-2"><strong>Reserv&shy;ation</strong></div>
      <div class="col-xs-4 remove-lp"><strong>Billing Status</strong></div>
      <div class="col-xs-2 remove-lp"><strong>Date</strong></div>
      <div class="col-xs-2 price"><strong>Amount</strong></div>
      <div class="col-xs-2"><strong></strong></div>
    </div>
    <hr class="billing-header" />
    <template v-if="reservations.length == 0">
      <div class="form-section-info">You have not had any reservations</div>
    </template>
    <template v-for="reservation in reservations">
      <div class="row billing-item">
        <div class="col-xs-2">
          #{{ reservation.reservationId }}
          <label v-if="!reservation.isPersonal" class="label label-info label-no-margin">B<span class="hide-small">usiness</span></label>
          <label v-if="reservation.isPersonal" class="label label-warning label-no-margin">P<span class="hide-small">ersonal</span></label>
        </div>
        <div class="col-xs-4 remove-lp">
          <span v-if="(reservation.completed || reservation.cancelled || reservation.expired) && !reservation.refunded" class="text-success">
            <span class="fa-stack">
              <span class="fa fa-circle fa-stack-2x"></span>
              <span class="fa fa-dollar fa-stack-1x fa-inverse"></span>
            </span>
            Billed
          </span>
          <span v-if="!reservation.completed && !reservation.cancelled && !reservation.expired" class="text-warning">
            <span class="fa-stack">
              <span class="fa fa-circle fa-stack-2x"></span>
              <span class="fa fa-clock-o fa-stack-1x fa-inverse"></span>
            </span>
              Waiting for reservation to finalise
          </span>
          <span v-if="reservation.refunded" class="text-info">
            <span class="fa-stack">
              <span class="fa fa-circle fa-stack-2x"></span>
              <span class="fa fa-exchange fa-stack-1x fa-inverse"></span>
            </span>
            Refunded
          </span>
        </div>
        <div class="col-xs-2 remove-lp">
          {{ reservation.startDate | short_date_format }}
        </div>
        <div class="col-xs-2 price">
          {{ reservation.actualCost ? reservation.actualCost : reservation.quotedCost | currency_round }}
        </div>
        <div class="col-xs-2">
          <a v-link="{ path: '/reservation/' + reservation.uuid }" class="btn-default btn btn-small"><span class="fa fa-search"></span> <span class="hide-small">View</span></a>
        </div>
      </div>
    </template>
    <center><br/>
      <paging-input :options="pagingOptions" v-if="reservations.length"></paging-input>
    </center><br/>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import PagingInput from '../inputs/PagingInput'

export default {
  name: 'ReservationChargesTab',
  components: {
    PagingInput
  },
  data () {
    return {
      reservations: [],
      pagingOptions: {
        totalResults: 10,
        limit: 10,
        current: 1
      },
      searchOffset: 0,
      searchLimit: 12
    }
  },
  ready () {
    this.getReservations()
  },
  events: {
    'changePage': function (page) {
      this.searchOffset = (page - 1) * this.searchLimit
      this.getReservations()
    }
  },
  methods: {
    getReservations () {
      let authType = this.$route.authType
      this.$http.get(`${authType}/reservation-billing`, { params: { offset: this.searchOffset, limit: this.searchLimit } }).then((response, status, request) => {
        this.reservations = response.data.reservations
        let now = moment()
        this.reservations.forEach(reservation => {
          if (now.isAfter(reservation.endDate)) reservation.expired = true
        })
        this.pagingOptions.current = (this.searchOffset / this.searchLimit) + 1
        this.pagingOptions.totalResults = response.data.count
        this.pagingOptions.limit = this.searchLimit
        this.$nextTick(function () {
          this.$broadcast('pagesUpdated', this.pagingOptions)
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReservationChargesTab.vue?24f2551f